import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import InfoBanner from '../../../components/Banner';
import BulletList from '../../../components/common/BulletList';
import { BulletBox } from '../../../asset/styled/PreviousEmploymentStyled';

const ErrorStep = ({ errorType, onRetry, onSkip }) => {
  const { t } = useTranslation('previousEmployment');

  const renderServerBusy = () => (
    <>
      <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-line' }}>
        {/* 서버 사용량이 많아\n미리 보기를 생성할 수 없어요. */}
        {t('errorSection.serverBusy.title')}
      </Typography>
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
        {/* 다음 입력 화면에 정보를 직접 입력해 주세요.\n첨부 파일은 정상적으로 업로드되었어요. */}
        {t('errorSection.serverBusy.description')}
      </Typography>
      <InfoBanner
        title={t('errorSection.serverBusy.noticeTitle')}
        description={t('errorSection.serverBusy.noticeDescription')}
      />
    </>
  );

  const renderFileError = () => (
    <>
      <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-line' }}>
        {/* 파일 정보를 확인할 수 없어요. */}
        {t('errorSection.fileError.title')}
      </Typography>
      <Typography variant="body2Medium">{t('errorSection.fileError.description')}</Typography>
      <BulletBox>
        <BulletList markerColor="var(--GrayScale-900)">
          <li>
            <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
              {/* 파일이 암호화되어 있나요?\n(예: DRM 같은 보안 프로그램 사용) */}
              {t('errorSection.fileError.item1')}
            </Typography>
          </li>
          <li>
            <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
              {/* 비밀번호가 설정되어 있나요?\n(예: PDF 파일에 비밀번호가 설정됨) */}
              {t('errorSection.fileError.item2')}
            </Typography>
          </li>
          <li>
            <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
              {/* 파일이 손상되었거나 열리지 않나요? */}
              {t('errorSection.fileError.item3')}
            </Typography>
          </li>
        </BulletList>
      </BulletBox>
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
        {/* 지금 상태로 계속 진행할 수 있어요.\n하지만 나중에 검토 시 파일 내용이 확인되지 않으면, 해당 내역은 삭제될 수 있어요. */}
        {t('errorSection.fileError.notice')}
      </Typography>
    </>
  );

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      {errorType === 'serverBusy' ? renderServerBusy() : renderFileError()}
      <div className="displayFlex" style={{ gap: '8px' }}>
        {/* 건너뛰기 */}
        <Button color="secondary" onClick={onSkip} value={t('errorSection.skipButton')} />
        {/* 다시 올리기 */}
        <Button style={{ flex: 1 }} onClick={onRetry} value={t('errorSection.retryButton')} />
      </div>
    </div>
  );
};

export default ErrorStep;
